import api from "./api";

export default class SimulatorAPI {
  static getSimulation = async (
      idCliente: number, 
      idVenda: number, 
      idBandeira: number, 
      idforma: string, 
      valor: number, 
      vlReverse: boolean 
    ) => {
    const response = await api.get(`/Simulador?idCliente=${idCliente}&idProduto=${idVenda}&idBandeira=${idBandeira}&idforma=${idforma}&valor=${valor}&vlreverse=${vlReverse}`);
    return response.data;
  };
};
